import { useApiWithAuth } from "@/modules/api";

interface DashboarPayload {
  saldo?: string | null;
  balance?: string | null;
  fila?: string | null;
  sigla?: string | null;
  statusrobo?: string | null;
  qtde?: number | null;
  groupIndex?: number | null;
}

interface SaldosReturn {
  saldo?: string;
  balance?: string;
}

interface OrgaoRoboStatusPayload {
  idOrgao?: number | null;
  sigla?: string | null;
  nome?: string | null;
  consultaHabilitado?: boolean | null;
  cadastroHabilitado?: boolean | null;
  art?: boolean | null;
}

const useDashboardService = () => {
  const { data, loading, get, put } = useApiWithAuth();

  const getDadosFilaRobo = (page: number): Promise<void> => {
    return get(`/root/robo/fila`, {
      ...{
        page: page
      }
    });
  };

  const isRoboCadastroHabilitado = (): Promise<void> => {
    return get(`/root/robo/cadastro`);
  };

  const isRoboConsultaHabilitado = (): Promise<void> => {
    return get(`/root/robo/consulta`);
  };

  const getSaldoHcaptcha = (): Promise<void> => {
    return get(`/root/dashboard/saldohcaptcha`);
  };

  const getSaldoAntiCaptcha = (): Promise<void> => {
    return get(`/root/dashboard/saldoanticaptcha`);
  };

  const desligarRoboConsulta = (): Promise<void> => {
    return put(`/root/robo/consulta/stop`);
  };

  const ligarRoboConsulta = (): Promise<void> => {
    return put(`/root/robo/consulta/start`);
  };

  const desligarRoboCadastro = (): Promise<void> => {
    return put(`/root/robo/cadastro/stop`);
  };

  const ligarRoboCadastro = (): Promise<void> => {
    return put(`/root/robo/cadastro/start`);
  };

  const getOrgaosRoboStatus = (): Promise<void> => {
    return get(`/root/robo/orgaos`);
  };

  const ligarRoboConsultaOrgao = (idOrgao: number): Promise<void> => {
    return put(`/root/robo/consulta/${idOrgao}/start`);
  };

  const desligarRoboConsultaOrgao = (idOrgao: number): Promise<void> => {
    return put(`/root/robo/consulta/${idOrgao}/stop`);
  };

  const ligarRoboCadastroOrgao = (idOrgao: number): Promise<void> => {
    return put(`/root/robo/cadastro/${idOrgao}/start`);
  };

  const desligarRoboCadastroOrgao = (idOrgao: number): Promise<void> => {
    return put(`/root/robo/cadastro/${idOrgao}/stop`);
  };

  const getFila = (entity?: DashboarPayload) => {
    if (!entity) {
      return "";
    }
    return entity.fila;
  };

  const getSigla = (entity?: DashboarPayload) => {
    if (!entity) {
      return "";
    }
    return entity.sigla;
  };

  const getStatusRobo = (entity?: DashboarPayload) => {
    if (!entity) {
      return "";
    }
    return entity.statusrobo;
  };

  const getQuantidade = (entity?: DashboarPayload) => {
    if (!entity) {
      return "";
    }
    return entity.qtde;
  };

  return {
    data,
    loading,
    isRoboCadastroHabilitado,
    isRoboConsultaHabilitado,
    getDadosFilaRobo,
    getSaldoHcaptcha,
    getSaldoAntiCaptcha,
    desligarRoboConsulta,
    ligarRoboConsulta,
    desligarRoboCadastro,
    ligarRoboCadastro,
    getOrgaosRoboStatus,
    ligarRoboConsultaOrgao,
    desligarRoboConsultaOrgao,
    ligarRoboCadastroOrgao,
    desligarRoboCadastroOrgao,
    getFila,
    getSigla,
    getStatusRobo,
    getQuantidade
  };
};

export {
  useDashboardService,
  DashboarPayload,
  SaldosReturn,
  OrgaoRoboStatusPayload
};
